import { render, staticRenderFns } from "./cards-table.vue?vue&type=template&id=ca547b56&"
import script from "./cards-table.vue?vue&type=script&lang=ts&"
export * from "./cards-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports